/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { CountrySubject } from './CountrySubject'
import {
  CountrySubjectFromJSON,
  CountrySubjectFromJSONTyped,
  CountrySubjectToJSON,
} from './CountrySubject'

/**
 *
 * @export
 * @interface GetCountrySubjects200Response
 */
export interface GetCountrySubjects200Response {
  /**
   *
   * @type {boolean}
   * @memberof GetCountrySubjects200Response
   */
  status: boolean
  /**
   *
   * @type {Array<CountrySubject>}
   * @memberof GetCountrySubjects200Response
   */
  data: Array<CountrySubject>
}

/**
 * Check if a given object implements the GetCountrySubjects200Response interface.
 */
export function instanceOfGetCountrySubjects200Response(
  value: object
): value is GetCountrySubjects200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function GetCountrySubjects200ResponseFromJSON(
  json: any
): GetCountrySubjects200Response {
  return GetCountrySubjects200ResponseFromJSONTyped(json, false)
}

export function GetCountrySubjects200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetCountrySubjects200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: (json['data'] as Array<any>).map(CountrySubjectFromJSON),
  }
}

export function GetCountrySubjects200ResponseToJSON(
  value?: GetCountrySubjects200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: (value['data'] as Array<any>).map(CountrySubjectToJSON),
  }
}
